import React from 'react';
import {
	ExpansionPanel,
	Card,
	CardContent,
	ExpansionPanelSummary,
	Icon,
	Typography,
	ExpansionPanelDetails
} from '@material-ui/core';
import LifeCover from './BenefitQuestions/LifeCover.jsx';
import CriticalIllness from './BenefitQuestions/CriticalIllness.jsx';
import DisabilityLumpsum from './BenefitQuestions/DisabilityLumpsum.jsx';
import ExtIncomeProtector from './BenefitQuestions/ExtIncomeProtector.jsx';
import TempIncomeProtector from './BenefitQuestions/TempIncomeProtector.jsx';
import DeathIncomeProtector from './BenefitQuestions/DeathIncomeProtector.jsx';

import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';

class BenefitDetails extends React.Component {
	state = {
		
	};

	

	componentDidMount() {
		this.props.scrollMeBar();
	}

	render() {
		

		

		return (
			<div className="contentWithStepper">
				<Card>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="Benefit Details"
						/>
						
						

						
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default BenefitDetails;


/*

{filteredBenefit.map((benefit, i) => {
							return (
								<ExpansionPanel defaultExpanded={i === 0} key={i}>
									<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
										<Typography
											variant="subheading"
											style={{ fontWeight: 'normal' }}
										>
											{benefit.name}
										</Typography>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{benefit.component(this.props)}
									</ExpansionPanelDetails>
								</ExpansionPanel>
							);
						})}

						*/


// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/BenefitDetails.jsx